import { getItemToUploadCountQuery } from '@/graphql/query';
import { useProfile } from '@/hooks/useProfile';
import { useQuery } from '@apollo/client';

export const useBlockchainCount = () => {
  const user = useProfile();

  const { data } = useQuery(getItemToUploadCountQuery, {
    skip: !user.permissions.has('manage_data'),
    fetchPolicy: 'cache-and-network'
  });

  return data?.getItemToUploadCount;
};
